// Utils
import { propIn } from '../../../common/utils/immutableHelper';

export const hybridAppIsForegroundSelector = propIn(['app', 'hybridApp', 'isForeground']);
export const hybridAppIsActiveSelector = propIn(['app', 'hybridApp', 'isActive']);
export const hybridAppNativeThemeSelector = propIn(['app', 'hybridApp', 'nativeTheme']);
